export default __webpack_public_path__ + "static/media/asset-planet.8c4be5af.png";